import { useUpdateCreditCardApplicationQuery } from "@lending/hooks/queries/CreditCardApplication/useUpdateCreditCardApplicationQuery";
import { useGetCreditCardProductsQuery } from "@lending/hooks/queries/CreditCardProduct/useGetCreditCardProductsQuery";
import { useToastsContext } from "@lending/hooks/useToasts";
import { useFlowNavigation } from "@lending/navigation";
import { useStore } from "../../../../contexts/StoreContext";

function useSelectCardContent() {
  const { goNext } = useFlowNavigation();
  const { data: storeData, updateData } = useStore();
  const { creditCardProductsData } = useGetCreditCardProductsQuery();
  const updateApplication = useUpdateCreditCardApplicationQuery();
  const { showGenericErrorToast } = useToastsContext();

  async function handleCardClick(cardId: string) {
    // If we're in the OLB flow, the application already exists — update it with the selected product
    if (storeData.lendingApplicationID) {
      try {
        await updateApplication.mutateAsync({
          params: { path: { uuid: storeData.lendingApplicationID } },
          body: { product: cardId },
        });
      } catch {
        showGenericErrorToast();
        return;
      }
    }

    updateData({ selectedProduct: cardId });
    goNext();
  }

  return {
    handleCardClick,
    creditCardProducts: creditCardProductsData.results,
  };
}

export { useSelectCardContent };
